<template>
    <div class="generate-code-container w-100">
        <div class="d-flex justify-content-start flex-column w-100">
            <h1 class="header mb-4 desktop-view">Get QR code</h1>
            <h1 class="header mb-3 mobile-view">Follow steps in Nametag app</h1>
        </div>
        <div v-if="errorMessage || errorMessageToShow" class="identity-failure-container"><img class="error-image"
                src="../assets/images/error_icon.png" alt="Error Image" />
            <p class="identity-validation mb-0 text-mobile-center" v-html="errorMessage + errorMessageToShow">
            </p>
        </div>
        <div class="get-qr-code-parent-wrapper w-100 d-flex flex-row justify-content-between align-items-start">
            <div class="left-wrapper d-flex flex-column justify-content-start align-items-start text-center">
                <h2 class="get-qr-header mt-0 mb-2">Let's get started</h2>
                <p class="sub-header desktop-view">Great, Follow the instructions in the app. When Nametag asks you to scan a QR code, click on generate the QR code. </p>
                <p class="sub-header mobile-view">Go to the Nametag app and follow the steps to verify your identity. When you are done, come back to this screen to complete your verification. </p>
                <div class="d-flex flex-row justify-content-end w-100 redirect-button">
                    <button class="btn flat-btn gray-btn cancel-button cursor-pointer desktop-view align-items-center" @click="generateQRCode"
                    :disabled="!!errorMessage">Generate QR Code</button>
                    <button class="btn flat-btn gray-btn cancel-button cursor-pointer mobile-view mobile-width mb-4" @click="generateQRCode"
                    :disabled="!!errorMessage">Go to Nametag
                    App</button>
                </div>
            </div>

            <div class="right-wrapper">
                <div class="line-container d-flex align-items-center desktop-view">
                    <p class="inline-text text-left ml-0 mt-2">Or you can copy and paste the link into a new browser window on
                        this computer.
                    </p>
                </div>

                <div class="copy-link-container d-flex align-items-center desktop-view">
                    <input type="text" v-model="link" class="form-input text-center mt-1" readonly />
                    <a @click="copyLink" class="copy-link cursor-pointer">{{ popupText }}</a>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end w-100 form-button-container">
            <div class="button-container w-100 d-flex justify-content-end">
                <button class="btn flat-btn gray-btn cancel-button cursor-pointer mt-3 ml-3" @click="cancelStep">Cancel</button>
                <button @click="showManualVerification"
                    v-if="errorMessageToShow && errorMessageToShow === (isContingent ? errorMessages.Nametag_Verification_Failure_Contingent :errorMessages.Nametag_Verification_Failure)"
                    class="btn flat-btn primary-blue-btn next-button mt-3 ml-3">{{
            errorButtonText }}</button>
                <button
                    v-if="!(errorMessageToShow && errorMessageToShow === (isContingent ? errorMessages.Nametag_Verification_Failure_Contingent :errorMessages.Nametag_Verification_Failure))"
                    class="btn flat-btn primary-blue-btn next-button mt-3 ml-3" @click="nextStep">Next</button>
            </div>
        </div>
        <loading-overlay v-if="isLoading"></loading-overlay>
    </div>
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import { nametagUserVerification } from '@/api/index.js';
import CONSTANTS from "@/constants";
export default {
    name: "GenerateQRCode",
    components: {
        LoadingOverlay
    },
    props: {
        link: {
            type: String,
            required: true
        },
        errorMessage: {
            type: String,
            required: false
        },
        email: {
            type: String,
            required: true
        },
        isContingent: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            popupText: "Copy link",
            errorMessageToShow: "",
            hasError: false,
            isLoading: false,
            errorButtonText: "Next",
            errorMessages: CONSTANTS.ERROR_MESSAGES
        };
    },
    methods: {
        copyLink() {
            navigator.clipboard.writeText(this.link).then(() => {
                this.popupText = "Copied!";
                setTimeout(() => {
                    this.popupText = "Copy Link";
                }, 3000); // Reset the popup text after 3 seconds
            });
        },
        generateQRCode() {
            window.open(this.link, "_blank");
        },
        showManualVerification() {
            this.errorButtonText === 'Retry' ? this.$router.push('/') : this.$emit("showManualVerification");
        },
        cancelStep() {
            document.title = 'Enterprise Search';
            this.$router.push('/');
        },
        async nextStep() {
            this.isLoading = true;
            try {
                const response = await nametagUserVerification(this.email);
                const data = await response.json();

                if (data.statusCode == 200) {
                    if (data.nametag_verification_status.includes("Not Verified")) {
                        this.hasError = true;
                        this.errorMessageToShow = this.errorMessages.Nametag_Verification_In_Progress;
                    } else if (data.nametag_verification_status.includes("Failed") && !data.retry) {
                        this.hasError = true;
                        this.errorButtonText = 'Retry';
                        this.errorMessageToShow = this.isContingent ? this.errorMessages.Nametag_Verification_Failure_Contingent :this.errorMessages.Nametag_Verification_Failure;
                    } else {
                        this.$emit("nextStep", data, 3);
                    }
                } else {
                    this.hasError = true;
                }
            } catch (error) {
                this.hasError = true;
                this.errorMessageToShow = this.errorMessages.Nametag_Verification_In_Progress;
            } finally {
                this.isLoading = false;
            }

        }
    }
};
</script>

<style scoped>
.generate-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    max-width: 1200px;
    color: black;
    font-family: artifaktElementRegular;
    padding: 0px 10px;
    margin-top: 20px;
}

.left-wrapper {
    width: 48%;
}

.right-wrapper {
    width: 48%;
    border-left: 1px solid gray;
    padding-left: 30px;
}

.mobile-view {
    display: none !important;
}

.desktop-view {
    display: flex !important;
}

.identity-failure-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
    padding: 5px 10px;
    justify-content: flex-start;
    width: 100%;
    font-size: 14px;
    border: 1px solid #CC4B24;
    background-color: #FAEDE9;
}

.error-image {
    width: 30px;
    margin-right: 10px;
}

.identity-validation {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
}

.header {
    font-size: 20px;
    font-weight: bolder;
    color: black;
    font-family: sans-serif;
    margin: 20px 0px;
}

.link {
    color: red !important;
    word-break: break-all;
    text-decoration: underline;
}

.identity-validation .error-link {
    color: red !important;
    text-decoration: underline;
}

.get-qr-header {
    font-size: 16px;
    color: black;
    font-family: artifaktElementRegular;
    font-weight: bolder;
    margin-top: 0px !important;
}

.sub-header {
    font-size: 15px;
    text-align: left;
}

.form-input {
    width: 400px;
    padding: 8px;
    margin-right: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.copy-link-container {
    margin-bottom: 16px;
}

.copy-link {
    color: #000000 !important;
    padding: 8px 10px;
    font-size: 14px;
    width: 100px;
}

.button {
    color: white;
    background-color: #000000;
    padding: 6px 40px;
    border-radius: 40px;
    font-weight: 700;
    font-size: 12px;
    border: none;
}

.line-container {
    width: 80%;
    margin: 20px 0;
}

.line {
    flex: 1;
    height: 1px;
    background-color: #ccc;
    border: none;
}

.inline-text {
    width: 93%;
    margin: 0 10px;
    font-size: 15px;
}

.cancel-button {
    background-color: white;
    min-width: 80px !important;
    height: 40px;
    text-transform: capitalize;
    border-radius: 4px !important;
    color: #000000 !important;
    max-width: 190px;
}
.cancel-button:hover {
    background-color: transparent !important;
    color: inherit !important;
}

.next-button {
    text-transform: capitalize;
    min-width: 80px !important;
    height: 40px;
    color: white;
    border: none;
    border-radius: 4px !important;
    max-width: 190px;
}

.btn:disabled {
    opacity: 0.35 !important;
}

.next-button:hover:not(:disabled) {
    background-color: #5a52d1;
}

.next-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.error-message {
    color: red;
    font-size: 14px;
}

.button-container {
    padding-right: 30px;
}

.form-input-mobile {
    display: none;
}

@media (max-width: 700px) {
    .form-input {
        display: none;
    }

    .generate-code-container {
        padding: 0px;
    }

    .header {
        margin: 0px !important;
        font-size: 18px;
    }

    .sub-header {
        margin-bottom: 14px !important;
        margin-top: 10px;
        text-align: center !important;
    }

    .form-button-container {
        flex-direction: column;
    }

    .line-container {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 0px !important;
    }

    .identity-failure-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

    .error-image {
        width: 40px;
        margin: 0px;
    }

    .line {
        display: block !important;
        flex: none;
        width: 100%;
        margin: 0px;
        height: 1px;
    }

    .mobile-view {
        text-align: left !important;
        display: flex !important;
    }

    .mobile-width {
        max-width: 250px !important;
        margin-bottom: 0px !important;
    }

    .desktop-view {
        display: none !important;
    }

    .form-button-container {
        justify-content: center !important;
        align-items: center;
        padding: 0px !important;
    }

    .inline-text {
        width: 100%;
        display: block;
        margin: 5px 0px;
        white-space: inherit;
    }

    .redirect-button {
        justify-content: center !important;
    }

    .cancel-button {
        max-width: 190px;
        margin-left: 0px !important;
        align-items: center;
        justify-content: center;
    }

    .get-qr-header {
        display: none;
    }

    .left-wrapper, .right-wrapper {
        width: 100%;
        border: none;
        padding-left: 0px !important;
    }

    .copy-link-container {
        width: 100%;
        align-items: flex-start !important;
        flex-direction: column;
    }

    .form-input-mobile {
        display: block;
        width: 100%;
        padding: 8px;
        margin-right: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
    }

    .error-message {
        margin-top: 0px !important;
    }

    .get-qr-code-parent-wrapper {
        flex-direction: column !important;
    }

    .copy-link {
        padding: 10px 0px;
    }

    .button-container {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        padding: 0px !important;
        justify-content: center !important;
        margin-top: 20px;
    }

    .step-checkmark {
        font-size: 12px;
        color: black;
    }
}
</style>
